module.exports = __webpack_public_path__ + "e13e30b7ea88486d61247aa472ad79d3.woff";